import { apiFetch } from "../apiClient";
import { logError, logInfo } from "./loggingService";
import { API_BASE_URL } from "../utils/apiBaseUrl";

const TELEMETRY_ENDPOINT = process.env.REACT_APP_TELEMETRY_ENDPOINT || "/api/telemetry/events";

function resolveBaseUrl() {
    if (TELEMETRY_ENDPOINT.startsWith("http")) {
        return TELEMETRY_ENDPOINT;
    }
    return `${API_BASE_URL}${TELEMETRY_ENDPOINT.startsWith("/") ? TELEMETRY_ENDPOINT : `/${TELEMETRY_ENDPOINT}`}`;
}

export async function sendTelemetryEvent(event) {
    const payload = {
        eventType: event.eventType,
        source: event.source ?? "frontend",
        success: event.success ?? true,
        attributes: event.attributes ?? {},
        correlationId: event.correlationId ?? null,
    };

    try {
        await apiFetch(resolveBaseUrl(), {
            method: "POST",
            body: JSON.stringify(payload),
            headers: { "Content-Type": "application/json" },
        });
        logInfo("Telemetry event sent", { component: "telemetryService", eventType: payload.eventType });
    } catch (error) {
        logError("Telemetry event failed", error, { component: "telemetryService", payload });
        throw error;
    }
}

export async function trackTourCompletion(tourId, extra = {}) {
    return sendTelemetryEvent({
        eventType: "tour_completed",
        attributes: { tourId, ...extra },
        success: true,
    });
}

export async function trackPushDelivery(deviceToken, platform, success, extra = {}) {
    return sendTelemetryEvent({
        eventType: "push_delivery_client",
        success,
        attributes: { deviceToken, platform, ...extra },
    });
}
